module.exports = __webpack_public_path__ + "img/es.62197af5.png";